<template>
  <div class="demo-container">
    <b-card title="機台布局展示">
      <div class="layout-demo">
        <sag-layout-machines
          :layout-path="demoData.layoutPath"
          :machines="demoData.machines"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import SagLayoutMachines from '@/components/basic/SagLayoutMachines.vue'

export default {
  name: 'SagLayoutMachinesDemo',
  
  components: {
    SagLayoutMachines,
  },
  
  data: () => ({
    demoData: {
      layoutPath: '/images/demo-layout.svg',
      machines: [
        {
          machineCode: 'M001',
          x: 300,
          y: 250,
          status: 'green',
          demand: 500,
          production: 450,
          runtime: 120,
          wip: 50,
        },
        {
          machineCode: 'M002',
          x: 500,
          y: 250,
          status: 'yellow',
          demand: 300,
          production: 200,
          runtime: 90,
          wip: 100,
        },
        {
          machineCode: 'M003',
          x: 700,
          y: 250,
          status: 'red',
          demand: 800,
          production: 600,
          runtime: 180,
          wip: 200,
        },
        {
          machineCode: 'M004',
          x: 300,
          y: 500,
          status: 'green',
          demand: 400,
          production: 380,
          runtime: 150,
          wip: 20,
        },
        {
          machineCode: 'M005',
          x: 500,
          y: 500,
          status: 'green',
          demand: 600,
          production: 590,
          runtime: 200,
          wip: 10,
        },
        {
          machineCode: 'M006',
          x: 700,
          y: 500,
          status: 'yellow',
          demand: 350,
          production: 200,
          runtime: 60,
          wip: 150,
        },
      ],
    },
  }),
}
</script>

<style scoped>
.demo-container {
  padding: 20px;
}

.layout-demo {
  width: 1000px;
  height: 800px;
  border: 1px solid #ddd;
  margin: 0 auto;
  background: white;
}
</style>
